import { Reducer } from 'redux';
import { FuelType } from "models/FuelType";
import { IFuelTypeActions, FuelTypeActionType } from "redux/actions/settings/FuelTypeActions";

const initialState: FuelType[] | null = null;
export const fuelTypesReducer: Reducer<FuelType[] | null, IFuelTypeActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case FuelTypeActionType.FETCH_FUELTYPES_SUCCESS:
                {
                    return action.returnPayload as FuelType[];
                }
            case FuelTypeActionType.ADD_FUELTYPE_SUCCESS:
                {
                    let newFuelTypes = [...state!];
                    newFuelTypes.push({ ...action.returnPayload } as FuelType)
                    return newFuelTypes;
                }
            case FuelTypeActionType.EDIT_FUELTYPE_SUCCESS:
            case FuelTypeActionType.DELETE_FUELTYPE_SUCCESS:
                {
                    let newManufs = [...state!];
                    const updatedFuelType = { ...action.returnPayload } as FuelType;
                    newManufs = newManufs.map(nm => nm.id === updatedFuelType.id ? updatedFuelType : nm);
                    return newManufs;
                }
            default:
                return state;
        }
    };
